/* Loveleen Sari Palace — lookbook category filter + accessible lightbox */
(function () {
  /* ---------------------------------------------------------------
     FILTER
  --------------------------------------------------------------- */
  function initLookbook(root) {
    if (!root || root.getAttribute('data-lsp-init') === 'true') return;
    root.setAttribute('data-lsp-init', 'true');

    var filters = root.querySelectorAll('.filter');
    var cards = root.querySelectorAll('.card');
    var live = root.querySelector('[data-lb-live]');

    if (!filters.length || !cards.length) return;

    Array.prototype.forEach.call(filters, function (btn) {
      btn.setAttribute('type', 'button');

      btn.addEventListener('click', function (e) {
        e.preventDefault();

        Array.prototype.forEach.call(filters, function (b) {
          b.classList.remove('active');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('active');
        btn.setAttribute('aria-pressed', 'true');

        var cat = btn.textContent.trim();
        var shown = 0;

        Array.prototype.forEach.call(cards, function (card) {
          var raw = (card.getAttribute('data-cat') || '');
          var cardCats = raw.split(',').map(function (s) { return s.trim().toLowerCase(); });
          var show = cat === 'All' || cardCats.indexOf(cat.toLowerCase()) !== -1;
          card.style.display = show ? '' : 'none';
          if (show) shown++;
        });

        if (shown === 0) {
          Array.prototype.forEach.call(cards, function (card) { card.style.display = ''; });
          if (live) live.textContent = 'No ' + cat.toLowerCase() + ' looks on the floor right now — showing everything.';
        } else if (live) {
          live.textContent = 'Showing ' + shown + ' ' + (cat === 'All' ? '' : cat.toLowerCase() + ' ') + (shown === 1 ? 'look' : 'looks') + '.';
        }
      });
    });
  }

  /* ---------------------------------------------------------------
     LIGHTBOX — tap a photo to view it large
  --------------------------------------------------------------- */
  var lb = null, lbImg = null, lbCap = null, lbLive = null;
  var gallery = [], current = -1, lastFocused = null;

  function buildLightbox() {
    if (lb) return lb;

    lb = document.createElement('div');
    lb.className = 'lsp-lightbox';
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.setAttribute('aria-label', 'Photo viewer');
    lb.hidden = true;

    lb.innerHTML =
      '<button type="button" class="lb-close" aria-label="Close photo viewer">&times;</button>' +
      '<button type="button" class="lb-prev" aria-label="Previous photo">&#8249;</button>' +
      '<figure class="lb-figure">' +
        '<img class="lb-img" src="" alt="">' +
        '<figcaption class="lb-cap"></figcaption>' +
      '</figure>' +
      '<button type="button" class="lb-next" aria-label="Next photo">&#8250;</button>' +
      '<div class="lb-live sr-only" aria-live="polite"></div>';

    document.body.appendChild(lb);

    lbImg = lb.querySelector('.lb-img');
    lbCap = lb.querySelector('.lb-cap');
    lbLive = lb.querySelector('.lb-live');

    lb.querySelector('.lb-close').addEventListener('click', closeLightbox);
    lb.querySelector('.lb-prev').addEventListener('click', function () { step(-1); });
    lb.querySelector('.lb-next').addEventListener('click', function () { step(1); });

    /* Click the dark backdrop to close (but not the image itself) */
    lb.addEventListener('click', function (e) {
      if (e.target === lb || e.target.classList.contains('lb-figure')) closeLightbox();
    });

    /* Keyboard: Esc closes, arrows navigate, Tab is trapped inside */
    lb.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeLightbox(); return; }
      if (e.key === 'ArrowLeft') { step(-1); return; }
      if (e.key === 'ArrowRight') { step(1); return; }
      if (e.key === 'Tab') {
        var f = lb.querySelectorAll('button');
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });

    /* Swipe on touch devices */
    var startX = null;
    lb.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    lb.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 50) step(dx > 0 ? -1 : 1);
      startX = null;
    }, { passive: true });

    return lb;
  }

  function show(i) {
    if (!gallery.length) return;
    current = (i + gallery.length) % gallery.length;
    var item = gallery[current];
    lbImg.src = item.src;
    lbImg.alt = item.title ? item.title : 'Enlarged photo';
    lbCap.textContent = item.title + (item.cat ? ' · ' + item.cat : '');
    lbLive.textContent = 'Photo ' + (current + 1) + ' of ' + gallery.length + ': ' + item.title;

    var multi = gallery.length > 1;
    lb.querySelector('.lb-prev').style.display = multi ? '' : 'none';
    lb.querySelector('.lb-next').style.display = multi ? '' : 'none';
  }

  function step(dir) { show(current + dir); }

  function openLightbox(cards, index) {
    buildLightbox();
    lastFocused = document.activeElement;

    gallery = Array.prototype.filter.call(cards, function (c) {
      return c.style.display !== 'none';
    }).map(function (c) {
      var img = c.querySelector('img');
      var h3 = c.querySelector('h3');
      var cat = c.querySelector('.cat');
      return {
        src: img ? (img.currentSrc || img.src) : '',
        title: h3 ? h3.textContent.trim() : '',
        cat: cat ? cat.textContent.trim() : ''
      };
    }).filter(function (item) { return item.src; });

    if (!gallery.length) return;

    lb.hidden = false;
    document.body.style.overflow = 'hidden';
    show(index);
    lb.querySelector('.lb-close').focus();
  }

  function closeLightbox() {
    if (!lb) return;
    lb.hidden = true;
    document.body.style.overflow = '';
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  function initLightboxOn(root) {
    if (!root || root.getAttribute('data-lsp-lb') === 'true') return;
    root.setAttribute('data-lsp-lb', 'true');

    var cards = root.querySelectorAll('.card');

    Array.prototype.forEach.call(cards, function (card, i) {
      var photo = card.querySelector('.photo');
      if (!photo || !photo.querySelector('img')) return;

      photo.classList.add('is-zoomable');
      photo.setAttribute('role', 'button');
      photo.setAttribute('tabindex', '0');
      var title = card.querySelector('h3');
      photo.setAttribute('aria-label', 'View larger photo' + (title ? ' of ' + title.textContent.trim() : ''));

      function openThis() {
        /* index among currently-visible cards */
        var visible = Array.prototype.filter.call(cards, function (c) { return c.style.display !== 'none'; });
        openLightbox(cards, visible.indexOf(card));
      }

      photo.addEventListener('click', openThis);
      photo.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openThis(); }
      });
    });
  }

  /* ---------------------------------------------------------------
     BOOT
  --------------------------------------------------------------- */
  /* Blog article images — make every content image zoomable */
  function initArticleImages() {
    var scopes = document.querySelectorAll(
      '.article-template__content, .article-content, .rte, article .rte, [data-lsp-article]'
    );
    if (!scopes.length) return;

    var imgs = [];
    Array.prototype.forEach.call(scopes, function (scope) {
      Array.prototype.forEach.call(scope.querySelectorAll('img'), function (im) {
        if (im.closest('a')) return;                    // don't hijack linked images
        if (im.getAttribute('data-lsp-zoomed') === '1') return;
        if (im.naturalWidth && im.naturalWidth < 400) return;  // skip tiny icons
        im.setAttribute('data-lsp-zoomed', '1');
        imgs.push(im);
      });
    });

    if (!imgs.length) return;

    imgs.forEach(function (im, idx) {
      im.style.cursor = 'zoom-in';
      im.setAttribute('tabindex', '0');
      im.setAttribute('role', 'button');
      var label = im.getAttribute('alt');
      im.setAttribute('aria-label', 'View larger image' + (label ? ': ' + label.slice(0, 80) : ''));

      function open() {
        buildLightbox();
        lastFocused = document.activeElement;
        gallery = imgs.map(function (g) {
          return {
            src: g.currentSrc || g.src,
            title: (g.getAttribute('alt') || '').split('—')[0].split(':')[0].trim() || 'Photo',
            cat: ''
          };
        });
        lb.hidden = false;
        document.body.style.overflow = 'hidden';
        show(idx);
        lb.querySelector('.lb-close').focus();
      }

      im.addEventListener('click', open);
      im.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); }
      });
    });
  }

  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-lsp-lookbook]'), function (root) {
      initLookbook(root);
      initLightboxOn(root);
    });
    /* Also enable the lightbox on the occasions grid */
    Array.prototype.forEach.call(document.querySelectorAll('[data-lsp-zoom]'), initLightboxOn);
    /* And on blog article images */
    initArticleImages();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (!e.target.querySelector) return;
    var root = e.target.querySelector('[data-lsp-lookbook]');
    if (root) {
      root.setAttribute('data-lsp-init', 'false');
      root.setAttribute('data-lsp-lb', 'false');
      initLookbook(root);
      initLightboxOn(root);
    }
    var zoom = e.target.querySelector('[data-lsp-zoom]');
    if (zoom) { zoom.setAttribute('data-lsp-lb', 'false'); initLightboxOn(zoom); }
  });
})();
